import React from 'react';
import { useAuthStore } from '../../stores/authStore';
import UnderConstructionPage from './UnderConstructionPage';

interface SpecialtyProtectedRouteProps {
  children: React.ReactNode;
}

const SpecialtyProtectedRoute: React.FC<SpecialtyProtectedRouteProps> = ({
  children,
}) => {
  const { isSpecialtyActive, user } = useAuthStore();

  // Si la especialidad no está activa (false), mostrar página en construcción
  if (isSpecialtyActive === false) {
    return (
      <UnderConstructionPage
        specialty={user?.specialty}
        title={`${user?.specialty?.description || 'Especialidad'} en Construcción`}
        message={`La funcionalidad para ${user?.specialty?.description || 'esta especialidad'} está siendo desarrollada y estará disponible próximamente.`}
      />
    );
  }

  // Si la especialidad está activa (true) o es null (cargando), mostrar el contenido normal
  return <>{children}</>;
};

export default SpecialtyProtectedRoute;
